import { Component } from '@angular/core';
import {MatCard, MatCardTitle} from "@angular/material/card";
import {TranslateModule} from "@ngx-translate/core";
import {NgForOf} from "@angular/common";
import { Router } from '@angular/router';
import {MatGridList, MatGridTile} from "@angular/material/grid-list";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    MatCard,
    MatCardTitle,
    TranslateModule,
    NgForOf,
    MatGridList,
    MatGridTile
  ],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  cardTitles: string[] = [
    "HR related Complaints/ Grievances",
    "HContractor Worker's HR Complaints/ Grievances",
    "Gender Based Violence (GBV)",
    "Women's/Vulnerable's Property Rights-Legal Aid",
    "Fraud/Corruption Grievances Related Complaints/ Grievances",
    "Project Intervention Related Complaints/ Grievances of General Public",
    "Service-Related Complaints/ Grievances",
    "Complaints/ Grievances of Housing Societies",
    "Vendors/Consultants/ Service provider's Complaints/ Grievances"
  ];

  constructor(private router: Router,) {
  }
  goTo(){
    this.router.navigateByUrl('/complaint/add');
  }
}
